import {Controller} from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
    // activate foundation on connect
    connect() {
        $(this.element).foundation();
    }
}